import type { ParcoursDto, ParcoursResponse } from "../../../api/parcoursApi";

/** Maps the full Parcours response to a DTO suitable for PUT /parcours/{id}. */
export function parcoursResponseToDto(p: ParcoursResponse): ParcoursDto {
  return {
    title: p.title,
    description: p.description,
    longDescription: p.longDescription,
    contentMode: p.contentMode ?? "PROGRAMME",
    imageLink: p.imageLink,
    dates: p.dates.map((d) => ({
      date: d.date,
      startTime: d.startTime,
      endDate: d.endDate,
      endTime: d.endTime,
    })),
    lieuIds: p.lieux.map((l) => l.id),
    artistIds: (p.artists ?? []).map((a) => a.id),
    practicalInfos: p.practicalInfos.map(({ id: _id, ...rest }) => rest),
    resources: p.resources,
    sponsors: p.sponsors.map(({ id: _id, ...rest }) => rest),
    programmes: p.programmes.map((prg) => ({
      title: prg.title,
      subtitle: prg.subtitle,
      date: prg.date,
      time: prg.time,
      address: prg.address ?? undefined,
      addressName: prg.addressName,
      lieuId: prg.lieu?.id,
      imageLink: prg.imageLink,
      price: prg.price,
      tag: prg.tag,
    })),
    country: p.country,
    region: p.region,
    mainCommune: p.mainCommune,
    accessibility: p.accessibility,
    contact: p.contact,
    secondaryContact: p.secondaryContact,
    website: p.website,
    price: p.price,
    paid: p.paid,
  };
}
